import type {MouseEvent, ReactElement} from 'react';
import {useState} from 'react';
import React from 'react';
import {Text} from '@Components/text';
import './ai-image-tooltip-text.scss';
import {copyToClipboard} from '@Utils/clipboard.util';
import {GA4EventName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';

interface AiImageTooltipTextProps {
  prompt: string;
}

export function AiImageTooltipText({...props}: AiImageTooltipTextProps): ReactElement {
  const [isCopiedClicked, setIsCopiedClicked] = useState(false);
  const PROMPT_TEXT_LIMIT = 52;
  const onCopy = (e: MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    if ('href' in e.target) {
      void copyToClipboard(props.prompt);
      trackPosterBuilderGA4Events(GA4EventName.AI_IMAGE_PROMPT_COPY);
      setIsCopiedClicked(true);

      setTimeout(() => {
        setIsCopiedClicked(false);
      }, 2000);
    }
  };

  const validatePromptLength = (prompt: string): string => {
    return prompt.length > PROMPT_TEXT_LIMIT ? prompt.slice(0, PROMPT_TEXT_LIMIT) : prompt;
  };

  const prepareTooltipContentForAIImage = (): ReactElement => {
    const promptToShow = validatePromptLength(props.prompt);
    const copyText = isCopiedClicked ? window.i18next.t('pmwjs_copied') : window.i18next.t('pmwjs_copy');
    return (
      <Text
        onClick={onCopy}
        dangerouslySetInnerHTML
        className="body-xs"
        val={`'${promptToShow}' - <a class="body-xs-bold content-body-white cursor-pointer ai-image-tooltip-text">${copyText}</a>`}
      />
    );
  };

  return prepareTooltipContentForAIImage();
}
